import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as innovationIdeas from '../../innovation-ideas'

export const RESOURCE = {
  payload: {
    description:
      'A specific idea for consideration and implementation by Attain Innovation',
    dimension: innovationIdeas.RESOURCE.payload,
    level: 0,
    name: 'Innovation Idea',
    partialId: PartialId.Standard.create('innovation_idea'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
